var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIcFavorite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ic_favotire")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_favotire",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.98,8 C23.98,8 25.67,9.62 25.67,12.56 C25.67,14.79 23.61,16.88 23.19,17.28 L15.58,24.6 L7.99,17.28 L7.99,17.28 L7.99,17.28 C7.25,16.62 5.5,14.6 5.5,12.56 C5.5,9.62 7.17,8 10.19,8 C11.76,8 13.39,9.29 14.19,10.06 L15.54,11.31 L16.9,10.06 C17.73,9.29 19.37,8 20.9,8 L20.98,8 Z M20.9,6 C18.72,6 16.7,7.49 15.5,8.59 C14.39,7.49 12.37,6 10.19,6 C6.06,6 3.5,8.51 3.5,12.56 C3.5,16 6.59,18.71 6.6,18.72 L14.65,26.48 C15.1647091,26.9910004 15.9952909,26.9910004 16.51,26.48 L24.58,18.71 C25.3,18.02 27.67,15.52 27.67,12.55 C27.67,8.55 25.1,5.99 20.98,5.99 L20.9,6 Z",
    fill: "#B4B8C3",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFavorite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_favorite.b07a7d38.svg";
export { ForwardRef as ReactComponent };